var cannotLoadAjax = "Can not process your request";

$(document).ready(function () {
   var innovaApiUrl = $("#InnovaApiUrl").val();
   var innovaApiKey = $("#InnovaKey").val();
   var sku = $("#Tool").val();
   if(sku != null && sku != undefined && sku != ""){
     var url = innovaApiUrl + "/products/" + sku +"/videos/?r=" + Math.random();
     
    	$.ajax({
          type: "GET",
          crossOrigin: true,
          url: url,
          beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
          },
          error: function (request, status, error) {
            if(request.status != 0){
              alert(cannotLoadAjax);
            }
          },
          success: function (result) {
            if(result.message.success && result.data != "" && result.data.indexOf("/embed/") > 0){
              $("#productVideo").attr("src", result.data + "?muted=1&amp;autoplay=0&amp;autopause=0&amp;loop=1");
            	$("#productVideoContent").show();                       
            }else{
              $("#productVideoContent").hide();         
            }
          }
      });   
   } 
  
});

